/**
 * @generated SignedSource<<c6a20f753d11ec0685a1ae35bb12484d>>
 * @relayHash 87235854dba7eefd5e24e05d5cf7af2d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 44fa4ea51e6d3e65c5de112eaa21034f69aa6c84e41b52c5b639eef6fcc5ba0e

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type AbsoluteCloseButtonMutation$variables = {
  cloudId: string;
};
export type AbsoluteCloseButtonMutation$data = {
  readonly jira: {
    readonly devOps: {
      readonly optoutOfDevOpsIssuePanelNotConnectedState: {
        readonly errors: ReadonlyArray<{
          readonly extensions: {
            readonly __typename: "GenericMutationErrorExtension";
            readonly statusCode: number | null | undefined;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null | undefined;
          readonly message: string | null | undefined;
        }> | null | undefined;
        readonly success: boolean;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type AbsoluteCloseButtonMutation = {
  response: AbsoluteCloseButtonMutation$data;
  variables: AbsoluteCloseButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "statusCode"
    }
  ],
  "type": "GenericMutationErrorExtension"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AbsoluteCloseButtonMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraDevOpsMutation",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "JiraOptoutDevOpsIssuePanelNotConnectedPayload",
                "kind": "LinkedField",
                "name": "optoutOfDevOpsIssuePanelNotConnectedState",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AbsoluteCloseButtonMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraDevOpsMutation",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "JiraOptoutDevOpsIssuePanelNotConnectedPayload",
                "kind": "LinkedField",
                "name": "optoutOfDevOpsIssuePanelNotConnectedState",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ],
                            "type": "BulkMutationErrorExtension"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "44fa4ea51e6d3e65c5de112eaa21034f69aa6c84e41b52c5b639eef6fcc5ba0e",
    "metadata": {},
    "name": "AbsoluteCloseButtonMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "70a423be18ea5329a8f95bab14bb29dc";

export default node;
